import { ReactNode, useState } from 'react'
import { TooltipContainer, TooltipContent } from './HoverTooltip.styles'

interface HoverTooltipProps {
  value: ReactNode
  children: ReactNode
  position?: 'top' | 'bottom' | 'left' | 'right'
  disabled?: boolean
  className?: string
}

export function HoverTooltip({
  value,
  children,
  position = 'top',
  disabled = false,
  className,
}: HoverTooltipProps): JSX.Element {
  const [isVisible, setIsVisible] = useState(false)

  if (disabled || !value) {
    return <>{children}</>
  }

  return (
    <TooltipContainer
      className={className}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}>
      {children}
      {isVisible && <TooltipContent $position={position}>{value}</TooltipContent>}
    </TooltipContainer>
  )
}
